import "./App.scss";
import React, { useEffect, useState, lazy, Suspense } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import firebase from "firebase/compat/app";
import { connect } from "react-redux";
import { Spin } from "antd";
import { EventSourcePolyfill } from "event-source-polyfill";
const Login = lazy(() => import("./Container/Login"));
const AppLayout = lazy(() => import("./Container/Layout"));
import "firebase/compat/auth";
import "firebase/compat/messaging";
import webPackage from "../package.json";
import { SseEvents } from "./config/SseEvents";
import { warningMsg } from "./redux/services/notification";
import { operations as ScheduleOperations } from "./redux/ducks/schedule";
import {
  operations as AuthOperations,
  selectors as AuthSelectors,
} from "./redux/ducks/auth";

const AppRoutes = {
  Login: {
    target: "/login",
    component: (
      <Suspense
        fallback={
          <div className="loader">
            <Spin tip="Please wait ..." />
          </div>
        }
      >
        <Login />
      </Suspense>
    ),
    pageName: "Login",
  },
  Dashboard: {
    target: "/*",
    component: (
      <Suspense
        fallback={
          <div className="loader">
            <Spin tip="Please wait ..." />
          </div>
        }
      >
        <AppLayout />
      </Suspense>
    ),
    pageName: "Dashboard",
  },
};

function App({
  loggedInUser,
  autoLogin,
  addNotification,
  registerDevice,
  setDeviceInfo,
  setCurrentWatering,
  getCurrentWatering,
}) {
  const navigate = useNavigate();
  const { search } = useLocation();
  const [isLogin, setLogin] = useState(null);
  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      const queryParams =
        search.includes("client_id=sprinkler-alexa") ||
        search.includes("transfer-ownership");
      if (user) {
        setLogin(true);
        autoLogin({
          payload: queryParams ? { search, user } : { search: "", user },
        });
      } else {
        setLogin(false);
        navigate(`${AppRoutes.Login.target}${search}`);
      }
    });
  }, []);
  useEffect(async () => {
    if (firebase.messaging.isSupported() && loggedInUser._id) {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          const messaging = firebase.messaging();
          messaging
            .getToken({
              vapidKey:
                "BBTuGE_TV_YcK84Ox8sdlfa6oJBgdHwdFBgaPju-SzIQzzvNMk_bTDqTk0P_KevkSBzD4AcCopUCKUbRaPxddAk",
            })
            .then((token) => {
              const payload = {
                appType: "Web",
                timezoneOffset: new Date().getTimezoneOffset(),
                deviceName: window.navigator.userAgent,
                messagingToken: token,
                deviceInfo: {
                  name: window.navigator.userAgent,
                  version: webPackage.version,
                  os: window.navigator.platform,
                  type: "browser",
                },
              };
              registerDevice({ payload });
              // eslint-disable-next-line no-useless-escape
              messaging.onMessage((notification) => {
                addNotification({
                  payload: { ...notification.data, timestamp: new Date() },
                });
              });
            })
            .catch((err) => {
              console.log("Notification Error", err.toString());
              warningMsg("Notification Error", err.toString());
            });
        } else {
          console.log("Firebase notification is blocked", permission);
        }
      });
    } else {
      console.log("Firebase notification is not supported");
    }
    let eventSource;
    if (loggedInUser._id) {
      getCurrentWatering();
      const token = await firebase.auth().currentUser.getIdToken(true);
      eventSource = new EventSourcePolyfill(
        `${process.env.REACT_APP_SERVER}/auth/user/${loggedInUser._id}/events`,
        {
          headers: {
            "X-Authorization-Firebase": token,
            appType: "Web",
          },
        }
      );
      eventSource.onopen = (event) => {
        console.log("On Open", event);
      };
      eventSource.onmessage = (event) => {
        const { eventName, payload, userId } = JSON.parse(event.data);
        if (userId === loggedInUser._id) {
          switch (eventName) {
            case SseEvents.CONTROLLER_UPDATE:
              setDeviceInfo({ payload });
              break;
            case SseEvents.WATERING_UPDATE:
              setCurrentWatering(payload);
              break;
            default:
              console.log("Unhandled Event", eventName);
          }
        }
      };
      eventSource.onerror = () => {};
    }
    return () => {
      /**
       * Closing events channel on unmount
       */
      if (eventSource) {
        eventSource.close();
      }
    };
  }, [loggedInUser._id]);
  if (isLogin === true && loggedInUser._id) {
    return (
      <div className="App">
        <Routes>
          <Route
            exact
            path={AppRoutes.Login.target}
            element={AppRoutes.Login.component}
          />
          <Route
            path={AppRoutes.Dashboard.target}
            element={AppRoutes.Dashboard.component}
          />
        </Routes>
      </div>
    );
  }
  if (isLogin === false) {
    return (
      <div className="App">
        <Routes>
          <Route
            exact
            path={AppRoutes.Login.target}
            element={AppRoutes.Login.component}
          />
        </Routes>
      </div>
    );
  }
  return (
    <div className="loader">
      <Spin tip="Please wait ..." />
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  autoLogin: AuthOperations.autoLogin(dispatch),
  addNotification: AuthOperations.addNotifications(dispatch),
  getCurrentWatering: ScheduleOperations.getCurrentWatering(dispatch),
  setCurrentWatering: ScheduleOperations.setCurrentWatering(dispatch),
  registerDevice: AuthOperations.registerDevice(dispatch),
  setDeviceInfo: AuthOperations.setDeviceInfo(dispatch),
});

const mapStateToProps = (state) => ({
  loggedInUser: AuthSelectors.getUser(state),
  activeDevice: AuthSelectors.getActiveDevice(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
